import { analyticsClient } from '@databases/analytics';
import { InsertColumnAfterIcon } from '@databases/icons';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { Position } from '../../type';
import { insertFields } from '../actions/insert-fields';
import { submenu } from '../state/submenu-state';
import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';
import { ElementAfterShortCutWrapper, ElementBeforeIconWrapper } from '../ui/components';

/**
 * The config for adding an field to the right of a the currently selected cell(s).
 */
export const addFieldRightMenuItem: MenuItemBuilder = ({
  capabilities: { canDeleteFields },
  contentId,
  currentViewId,
  formatMessage,
}) => {
  return {
    isEnabled: () => canDeleteFields,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.ADD_FIELD_RIGHT,
      content: formatMessage(messages['field-actions.add-right']),
      onClick: async () => {
        await insertFields({
          position: Position.AFTER,
          client: analyticsClient,
          contentId,
          currentViewId,
          formatMessage,
        });
      },
      onMouseEnter: submenu.close,
      closeOnClick: true,
      elemAfter: (
        <ElementAfterShortCutWrapper
          tooltip={tooltip(SHORTCUTS.ADD_FIELD_RIGHT.keyMap)}
        />
      ),
      elemBefore: (
        <ElementBeforeIconWrapper>
          <InsertColumnAfterIcon label="" size="medium" />
        </ElementBeforeIconWrapper>
      ),
    },
  };
};
